module.exports = __webpack_public_path__ + "assets/img/header-bg@2x.7e3150d0.png";